import React from "react";
import ReqBox from "./ReqBox";

export default function Pinnacle({ pinnacle }) {
  const p = pinnacle || {
    name: "Star Elite (Pinnacle)",
    star: "10th Star Master Milestone – Ultimate Career Pinnacle",
    clients: "1,500+ Clients",
    connect: "2,500+ Nodes",
    rating: "5.0 ★ Elite",
    prereq: "Tier 9 Crown Master & Full Compliance Audit",
    commission: "15.0% Maximum Master Ceiling",
    benefits: [
      "All 10 Regional Hubs Nationwide Unlocked",
      "Lifetime Global Ambassador Status & Franchise Rights",
    ],
    status: "locked",
    subs: ["(1,500 req)", "(2,500 req)", "(5.0★ req)"],
  };

  const isCompleted = p.status === "completed";
  const isCurrent = p.status === "current";

  return (
    <div className="card marketing_level_card_pinnacle border-2 rounded-4 mt-4">
      <div className="card-body">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
          <div className="d-flex gap-3 align-items-center">
            <span
              className="rounded-3 bg-dark marketing_level_text_gold d-inline-flex align-items-center justify-content-center fs-4"
              style={{ width: 44, height: 44 }}
            >
              <i className="bi bi-trophy-fill" />
            </span>
            <div>
              <div className="fw-bold">
                Tier 10: {p.name}{" "}
                <span
                  className="badge marketing_level_bg_gold ms-2"
                  style={{ fontSize: 10 }}
                >
                  MAXIMUM 15% CEILING
                </span>
              </div>
              <div className="small marketing_level_text_gold">
                <i className="bi bi-star-fill me-1" />
                {p.star}
              </div>
            </div>
          </div>

          <span
            className={`badge ${
              isCompleted
                ? "marketing_level_bg_green"
                : isCurrent
                ? "bg-primary text-white"
                : "marketing_level_bg_gold"
            }`}
          >
            <i
              className={`bi ${
                isCompleted
                  ? "bi-check-circle-fill"
                  : isCurrent
                  ? "bi-person-fill"
                  : "bi-lock-fill"
              } me-1`}
            />
            {isCompleted
              ? "Completed (Elite Master)"
              : isCurrent
              ? "Current Standing (Tier 10)"
              : "Ultimate Goal (Locked)"}
          </span>
        </div>

        <div className="marketing_level_pinnacle_grid">
          <div className="marketing_level_min0">
            <div className="small fw-bold text-uppercase marketing_level_text_blue mb-2">
              <i className="bi bi-list-check me-1" />
              Requirement to get there:
            </div>
            <div className="marketing_level_req_gold rounded-3 p-2">
              <div className="row g-2">
                <ReqBox
                  label="Total Clients"
                  value={p.clients}
                  sub={p.subs?.[0]}
                />
                <ReqBox
                  label="Total Connect"
                  value={p.connect}
                  sub={p.subs?.[1]}
                />
                <ReqBox
                  label="Rating"
                  value={p.rating}
                  sub={p.subs?.[2]}
                />
              </div>
              <div className="small mt-2">
                <span className="marketing_level_text_muted">Prerequisite:</span>{" "}
                <strong>{p.prereq}</strong>
              </div>
            </div>
          </div>

          <div className="marketing_level_min0">
            <div className="small fw-bold text-uppercase marketing_level_text_blue mb-2">
              <i className="bi bi-gift me-1" />
              Benefits &amp; Privileges:
            </div>
            <div className="bg-white border rounded-3 p-3">
              <div className="small mb-2">
                <span className="marketing_level_text_muted">
                  Commission Rate:
                </span>{" "}
                <strong className="marketing_level_text_blue fs-6">
                  {p.commission}
                </strong>
              </div>
              {(p.benefits || []).map((b, i) => (
                <div key={i} className="small d-flex gap-2 mb-1">
                  <i className="bi bi-check2-circle marketing_level_text_green" />
                  <span>{b}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

